import { render, staticRenderFns } from "./arole.vue?vue&type=template&id=64ba06a0&scoped=true&"
import script from "./arole.vue?vue&type=script&lang=js&"
export * from "./arole.vue?vue&type=script&lang=js&"
import style0 from "./arole.vue?vue&type=style&index=0&id=64ba06a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba06a0",
  null
  
)

export default component.exports